import * as React from 'react';
import classnames from 'classnames';
import { Attributes } from '../types';
import Box from '../Box/Box';
import Text, { TextProps } from '../Text/Text';
import './TextInput.css';

export interface TextInputProps extends Omit<TextProps, 'size'> {
  /** */
  disabled?: boolean;
  /** */
  size?: 'small' | 'medium' | 'large';
}

const TextInput: React.ForwardRefRenderFunction<HTMLInputElement, Attributes<HTMLInputElement, TextInputProps>> = (props, ref) => {
  const {
    disabled,
    size = 'medium',
    ...rest
  } = props;

  const classes = classnames('TextInput', `TextInput--size-${size}`, {
    'TextInput--disabled': disabled,
  });

  return (
    <Box
        borderColor="gray"
        borderRadius="x1"
        borderSize="x1"
        className={ classes }>
      <Text { ...rest }
          className="TextInput__input"
          ref={ ref }
          size="x2"
          tag="input" />
    </Box>
  );
};

export default React.forwardRef(TextInput);
